<template>
  <FormInputWrapper class="overflow-hidden" :error="error" :label="label" :lang="lang" :note="note" :required="required">
    <AtomsWabunkaComboBox v-bind="$attrs" :default-value="defaultValue" :disabled="disabled" :is-error="isError" :lang="lang" :model-value="modelValue" :options="options" />
  </FormInputWrapper>
</template>

<script setup lang="ts">
import type { Lang } from '@/models/lang';
import type { Options } from '@/models/option';
import { FormInputWrapper } from '@/wabunka-src/common/components';

interface Props {
  label: string;
  note?: string;
  required?: boolean;
  error?: string;
  lang?: Lang;
  options?: Options;
  modelValue: string | number;
  defaultValue?: string | number;
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  note: '',
  required: true,
  error: '',
  lang: 'jp',
  options: () => [],
  modelValue: '',
  defaultValue: '',
  disabled: false,
});

const isError = computed(() => !!props.error && props.error !== '');
</script>
